import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const btnTypePropType = (props, propName) => {
  const str = props[propName];
  const types = ['primary', 'secondary', 'tertiary'];
  const deprecatedTypes = [
    'warning',
    'standard',
    'white',
    'gray',
    'primary-inverted',
    'green',
  ];
  const allTypes = [...types, ...deprecatedTypes];
  if (!allTypes.includes(str)) {
    return new Error(
      `Button Type accepts only ${allTypes.join(', ')}. you gave '${str}'.`
    );
  }
  if (deprecatedTypes.includes(str)) {
    // eslint-disable-next-line no-console
    console.warn(
      `Hey! Stop using '${str}' buttons. It's deprecated. Swap it out with one of these: ${types}.`
    );
  }

  return null;
};

const sizePropType = (props, propName) => {
  const str = props[propName];
  const sizes = ['small', 'medium', 'large'];
  const deprecatedSizes = ['normal'];
  const allSizes = [...sizes, ...deprecatedSizes];
  if (!allSizes.includes(str)) {
    return new Error(
      `Button Size accepts only small, medium, or large. you gave '${str}'.`
    );
  }
  if (deprecatedSizes.includes(str)) {
    // eslint-disable-next-line no-console
    console.warn(
      `Hey! Stop using '${str}' buttons. It's deprecated. Swap it out with one of these: ${sizes}.`
    );
  }

  return null;
};

const Button = props => {
  const {
    isLink,
    disabled,
    linkHref,
    target,
    method,
    children,
    handleClick,
    itemProp,
    useRouter,
    dataCy,
    rel,
    btnType,
    className,
    size,
    ...extraProps
  } = props;

  const finalClassName = classNames(
    'Button',
    `Button-${size}`,
    `Button-${btnType}`,
    {
      [`Button-${btnType}--disabled`]: disabled,
      'Button-isLink': isLink || useRouter,
    },
    className
  );

  if (isLink) {
    return (
      <a
        className={finalClassName}
        disabled={disabled}
        href={linkHref}
        onClick={handleClick}
        target={target}
        data-method={method}
        itemProp={itemProp}
        data-cy={dataCy}
        rel={rel}
        {...extraProps}
      >
        {children}
      </a>
    );
  }
  if (useRouter) {
    throw new Error('not implemented error');
  }
  return (
    <button
      className={finalClassName}
      disabled={disabled}
      onClick={handleClick}
      data-cy={dataCy}
      type="submit"
      {...extraProps}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  btnType: btnTypePropType,
  handleClick: PropTypes.func,
  size: sizePropType,
  disabled: PropTypes.bool,
  isLink: PropTypes.bool,
  linkHref: PropTypes.string.isRequired,
  target: PropTypes.string,
  method: PropTypes.string,
  useRouter: PropTypes.bool,
  className: PropTypes.string,
  itemProp: PropTypes.string,
  rel: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  dataCy: PropTypes.string,
};

Button.defaultProps = {
  className: '',
  size: 'medium',
  disabled: false,
  btnType: 'primary',
  isLink: false,
  target: '_self',
  method: null,
  handleClick: () => {},
  useRouter: false,
  dataCy: 'button',
  rel: undefined,
  itemProp: undefined,
};

export default Button;
